import { ActionTree } from "vuex";
import { StateInterface } from "src/store";
import { IIdomSettingsStateInterface } from "./state";
import API from "src/services/api/api";
import { ISettingsItem } from "src/modules/idom-settings/models/settings";

function groupSettings(settings: ISettingsItem[]) {
  const settingsGroup = settings.reduce(
    (acc, setting) => {
      if (!acc[setting.type_name]) {
        acc[setting.type_name] = [setting];
        return acc;
      }
      acc[setting.type_name].push(setting);
      return acc;
    },
    {} as Record<string, ISettingsItem[]>,
  );
  return Object.keys(settingsGroup).map((key) => ({
    name: key,
    settings: settingsGroup[key],
  }));
}

const actions: ActionTree<IIdomSettingsStateInterface, StateInterface> = {
  async updateSettings({ commit }, payload: { guid: string; value: string }[]) {
    try {
      const data: ISettingsItem[] = await API.sqlr.idom_update_setting(payload);
      commit("setSettings", groupSettings(data));
    } catch (e: any) {
      return e.response.data.message;
    }
  },

  async fetchSettings({ commit }) {
    try {
      const data: ISettingsItem[] = await API.sqlr.idom_get_settings();
      commit("setSettings", groupSettings(data));
    } catch (e) {}
  },
};

export default actions;
